import { MobileShell } from '@/components/dashboard/DashboardShell';
import { AcademicCalendarContent } from '@/components/dashboard/AcademicCalendarContent';

export default function AcademicCalendarMobile() {
  return <AcademicCalendarContent Shell={MobileShell} mode="mobile" />;
}
